<div class="bd-modal">
  <div class="bd-modal-header">
    <div>
      <span class="bd-modal-period">{{ data.period }}</span>
      <span class="bd-modal-total">{{ 'Total:' | translate }} {{ data.total }}</span>
    </div>
    <button class="bd-modal-close" (click)="close()">
      <i class="material-icons">close</i>
    </button>
  </div>
  <div class="bd-modal-rows">
    @for (row of data.rows; track trackByIndex($index)) {
      <div class="bd-modal-row">
        <span class="bd-modal-name">{{ row.name }}</span>
        <span class="bd-modal-val">{{ row.value }}</span>
      </div>
    }
  </div>
  @if (data.prior != null) {
    <div class="bd-modal-prior">
      {{ 'Prior Period:' | translate }} {{ data.prior }}
    </div>
  }
</div>
